module.exports = __webpack_public_path__ + "img/gh_79e71c45d614_430.jpg";